import React, { useState, useEffect } from 'react';
import { Container, CardPost } from 'Common';
import { Wrapper, Row } from './styles';

export const Articles = () => {
	const [articles, setArticles] = useState([]);

	useEffect(() => {
		fetchArticles();
	}, []);

	async function fetchArticles() {
		try {
			const data = await (
				await fetch(
					'https://cors-anywhere.herokuapp.com/https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@aboudicheng'
				)
			).json();
			const filtered = data.items.filter(item => item.categories.length);
			setArticles(filtered);
		} catch (e) {
			throw e;
		}
	}

	return (
		<Wrapper as={Container} id="articles">
			<h2>Articles</h2>
			<Row landing>
				{articles.map((article, i) => (
					<CardPost
						key={i}
						url={article.link}
						thumbnail={article.thumbnail}
						title={article.title}
						date={article.pubDate}
						landing
					/>
				))}
			</Row>
		</Wrapper>
	);
};
